// extracted by mini-css-extract-plugin
export default {"quickstartsHero":"quickstartsHero--3-tw9","quickstartsHeroImage":"quickstartsHeroImage--OukpS","quickstartsHeroTitle":"quickstartsHeroTitle--roe1B"};